import { ThemeConfig } from "./theme-config";

export const DEFAULT_THEME: ThemeConfig = {
    themeId: "default-theme-id",
    mainColors: {
        primaryColor: "#176ad2",
        accentColor: "#ffffff",
        warnColor: "#c791d4"
    },
    images: {
        primaryLogoUrl: "assets/images/Powerdby.png",
        secondaryLogoUrl: "assets/images/Powerdby.png",
        poweredByLogoUrl: null,
        bannerUrl: "assets/images/logo-white-horizontal.png",
        favIconUrl: "assets/icons/app-icon.png"
    }
};
